





















import Vue from 'vue'

export default Vue.extend({
  name: 'Score',
  props: {
    value: {
      type: Number,
    },
    readonly: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    isReadonly: function (): boolean {
      return this.readonly || this.loading
    },
  },
  data: () => ({}),
  methods: {
    changeScore: function (i: number) {
      if (this.isReadonly) {
        return
      }

      let newScore = i + 1

      if (newScore === this.value) {
        newScore = 0
      }

      this.$emit('input', newScore)
    },
  },
})
